import reportService from "@/api/reportService";
import VehicleService from "@/api/VehicleService";
import { notifyError } from "@/utils/notification-helper";
import moment from "moment-timezone";
// import { MESSAGES } from '@/utils/constants';
// import { notifyApiError, notify, notifyError } from '@/utils/notification-helper';

const state = {
    loader: false,
    distanceTravelledReport: [],
    distanceTravelledReportRequestBody: {
        columns: [
            { field: "RTONumber", title: "RTO No", dataType: "text" },
            { field: "DateString", title: "Date", dataType: "timestamp" },
            { field: "StartOdo", title: "Start Odo", dataType: "timestamp" },
            { field: "EndOdo", title: "End Odo", dataType: "timestamp" },
            { field: "startOdoReading", title: "Start Odometer", dataType: "text" },
            { field: "endOddoReading", title: "End Odometer", dataType: "text" },
            { field: "Distance", title: "Distance", dataType: "text" },
            { field: "IMEI", title: "IMEI", dataType: "text" }
        ],
        filters: [
            { fieldName: "RTONumber", fieldId: "RTONumber", operator: "eq", value: "", datatype: "String" },
            { fieldName: "Date", fieldId: "FromTime", operator: "gte", value: "", datatype: "Date" },
            { fieldName: "Date", fieldId: "ToTime", operator: "lte", value: "", datatype: "Date" }
        ],
    },
    ignitionOnOffReport: [],
    ignitionOnOffRequestBody: {
        "columns": [
            { field: "OnDateTime" },
            { field: "OnLocation" },
            { field: "OnKms" },
            { field: "OffDateTime" },
            { field: "OffLocation" },
            { field: "OffKms" },
            { field: "TotalKms" },
            { field: "TotalRunTime" }
        ],
        "filters": [
            { fieldName: "RTONumber", fieldId: "RTONumber", operator: "eq", value: "", datatype: "String" },
            { fieldName: "OnDateTime", fieldId: "OnDateTime", operator: "gte", value: "", datatype: "Date" },
            { fieldName: "OnDateTime", fieldId: "OffDateTime", operator: "lte", value: "", datatype: "Date" },
        ], "Component": ""
    },
    travelPathReport: [],
    travelPathReportRequestBody: {
        columns: [
            { field: "DateTime" },
            { field: "RTONumber" },
            { field: "IMENo" },
            { field: "Speed" },
            { field: "ODO" },
            { field: "Lat" },
            { field: "Lon" }
        ],
        filters: [
            { fieldName: "IMENo", fieldId: "IMENo", operator: "eq", value: "", datatype: "String" },
            { fieldName: "RTONumber", fieldId: "RTONumber", operator: "eq", value: "", datatype: "String" },
            { fieldName: "DateTime", fieldId: "FromTime", operator: "gte", value: "", datatype: "Date" },
            { fieldName: "DateTime", fieldId: "ToTime", operator: "lte", value: "", datatype: "Date" }
        ],
        Component: ""
    },
    vehicles: [],
    geofenceId:[],
}
const getters = {
    getLoaderStatus: (state) => state.loader,
    getDateTimeFormat: (state, getters, rootState, rootGetters) => rootGetters.getDateTimeFormat, 
    getVehicles: (state, getters, rootState, rootGetters) => rootGetters.getVehicles,
    getDistanceTravelledReport: (state) => state.distanceTravelledReport,
    getDistanceTravelledReportData: (state) => state.distanceTravelledReport,
    getIgnitionOnOffReport: (state) => state.ignitionOnOffReport,
    getTravelPathReport: (state) => state.travelPathReport,
    getGeofenceReportID:(state) => state.geofenceId,
    getTenantId:(state, getters, rootState)=> rootState.tenantData.tenantId
};

const actions = {
    async fetchDistanceTravelledReport({ commit, state,rootState }, filters) {
        console.log('rootState',rootState.reportServiceChannelKey)
        const payload = state.distanceTravelledReportRequestBody;
        payload.filters.map(element => {
            if (element.fieldId === "RTONumber") {
                element.value = filters.rtoNumber;
            } else if (element.fieldId === "FromTime") {
                element.value = filters.fromTime;
            } else if (element.fieldId === "ToTime") {
                element.value = filters.toTime;
            }
        });
         payload.ChannelKey = rootState.reportServiceChannelKey;
         payload.EntityName = "DailyDistanceReport";
        try {
            commit("setLoaderStatus", true);
            const response = await reportService.getReport(payload);
            const result = response.data.result.sort(
                (a, b) => new Date(b.DateString) - new Date(a.DateString)
            );
            console.log('response',response)
            commit('setDistanceTravelledReport', result);
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            commit("setLoaderStatus", false);
        }
    },
    async fetchIgnitionOnOffReport({ commit, state,rootState }, filters) {
        console.log("filters",filters)
        const payload = state.ignitionOnOffRequestBody;
        payload.filters.map(element => {
            if (element.fieldId === "RTONumber") {
                element.value = filters.rtoNumber;
            } else if (element.fieldId === "OnDateTime") {
                element.value = filters.fromTime;
            } else if (element.fieldId === "OffDateTime") {
                element.value = filters.toTime;
            }
        });
        payload.ChannelKey = rootState.reportServiceChannelKey;
        payload.EntityName = "IgnitionOnOffReport";
        
        try {
            commit("setLoaderStatus", true);
            console.warn('#time ',filters.fromTime, filters.toTime)
            const response = await reportService.getReport(payload);
            console.log()
            const result = response.data.result.map((rep) => {
                console.log('Results : ON ', rep.OnDateTime, moment(rep.OnDateTime).format("DD/MM/YYYY HH:mm:ss"),' off', rep.offDateTime);
                // let runtime = "";
                // if (rep.TotalRunTime) {
                //    const days = rep.TotalRunTime.days ?  rep.TotalRunTime.days + ' days ' : ""
                //    const hours = rep.TotalRunTime.hours ?  rep.TotalRunTime.hours : "0";
                //    const minutes = rep.TotalRunTime.minutes ?  rep.TotalRunTime.minutes : "0";
                //    const seconds = rep.TotalRunTime.seconds ?  rep.TotalRunTime.seconds : "0";
                //    runtime = days  + hours + ":" + minutes + ":" + seconds;
                // }
                return {
                    ...rep,
                    OnDateTime:  rep.OnDateTime ? moment(rep.OnDateTime).format("DD/MM/YYYY HH:mm:ss") : "",
                    OffDateTime: rep.OffDateTime ? moment(rep.OffDateTime).format("DD/MM/YYYY HH:mm:ss") : "",
                }
            });
            commit('setIgnitionOnOffReport', result);
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            commit("setLoaderStatus", false);
        }
    },
    async fetchTravelPathReport({ commit }, filters) {
       
        // const payload = state.travelPathReportRequestBody;
        // payload.filters.map(element => {
        //     if (element.fieldId === "IMENo") {
        //         element.value = filters.rtoNumber;
        //     } else if (element.fieldId === "FromTime") {
        //         element.value = filters.fromTime;
        //     } else if (element.fieldId === "ToTime") {
        //         element.value = filters.toTime;
        //     }
        // });
        console.log(filters)
        try {
            commit("setLoaderStatus", true);
            const response = await reportService.getTravelPathReport(filters);
            const result = response.data.map((tp) => {
                return {
                    ...tp,
                    rtoNumber:filters.rtoNo,
                    coordinate:tp.lat+','+tp.lng,
                    dateTime: tp.timestamp ? moment(tp.timestamp).format("DD/MM/YYYY HH:mm:ss") : "",
                }
            });
            commit('setTravelPathReport', result);
        } catch (error) {
            console.error('Error: ', error);
        } finally {
            commit("setLoaderStatus", false);
        }
    },
    async loadVehicles({ commit }) {
        try {
            const response = VehicleService.getVehicle();
            if (response.data.status) {
                commit('setVehicles', response.data.result);
            } else {
                notifyError(response.data.message);
            }
        } catch (error) {
            console.log(error.response.message);
        }
    },
    async fetchGeofenceId({ commit,rootState },) {
        try {
            const ChannelKey = rootState.geofenceChannelKey;
            const response = await reportService.getGeofenceId(ChannelKey);
            console.log("#geofence",response)
            //this.filteredGeofence = response.data.result.filter(id => id.metadata.properties.includes('geofenceName'))
           // console.log("#geofenceafter",this.filteredGeofence )

            if (response.data.result) {
                commit('setGeofenceId', response.data.result);
            } else {
                notifyError(response.data.message);
            }
        } catch (error) {
            console.log(error.response.message);
        }
    },
}
const mutations = {
    setLoaderStatus(state, status) {
        state.loader = status;
    },
    setDistanceTravelledReport(state, data) {
        state.distanceTravelledReport = data;
    },
    setIgnitionOnOffReport(state, data) {
        state.ignitionOnOffReport = data;
    },
    setTravelPathReport(state, data) {
        state.travelPathReport = data;
    },
    setVehicles(state, data) {
        state.vehicles = data;
    },
    setGeofenceId(state, data) {
        state.geofenceId = data;
        console.log("#geofence",data)

        
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}